import React from "react";
import { images, testimonials } from "../constant/data";
import verify from "../../../../../assets/verified.png"




const Testomonials = () => {
    return (
        <div className="bg-[#F4F5F7]">
            <div className=" mx-auto  px-8 space-y-5 py-12 max-w-7xl">

                <div className="w-full flex items-center justify-center">
                    <div className="w-60 h-4 bg-[#132C4D]" />

                </div>
                <h2 className="font-bold text-4xl text-center"  >
                    Real Lung Renew Users. Real Life-Changing Results

                </h2>
                <div className="flex flex-wrap justify-center gap-4">
                    {images.map((image) => (
                        <div
                            key={image.id}
                            className="w-48 h-56 border-[6px] border-b-[16px] border-white shadow-custom transform rotate-[-4deg]"
                        >
                            <img src={image.src} alt={image.alt} className="w-full h-52 object-cover" />
                        </div>
                    ))}
                </div>
            </div>



            {/* testoonials */}

            <div className="mx-auto max-7xl px-4 pb-10 space-y-5">
                <div className="max-w-xl mx-auto space-y-6">
                    {testimonials.map((testimonial) => (
                        <div
                            key={testimonial.id}
                            className="flex items-start gap-4 px-4 py-6 border border-black rounded-lg"
                        >
                            <img
                                src={testimonial.img}
                                alt={`${testimonial.name}`}
                                className="w-24 rounded-full object-cover"
                            />
                            <div className="space-y-2">
                                <p className="text-base text-[#212529]">{testimonial.text}</p>
                                <h1 className="text-xl font-bold">{testimonial.name}</h1>
                                <img
                                    src={verify}
                                    alt="Verified"
                                    className="w-44"
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>

    );
};

export default Testomonials;
